//https://colorbrewer2.org/
const GnBu:`#${string}`[] = ['#f7fcf0','#e0f3db','#ccebc5','#a8ddb5','#7bccc4','#4eb3d3','#2b8cbe','#0868ac','#084081']
const OrRd:`#${string}`[] = ['#fff7ec','#fee8c8','#fdd49e','#fdbb84','#fc8d59','#ef6548','#d7301f','#b30000','#7f0000']
const BuPu:`#${string}`[] = ['#fff7fb','#ece7f2','#d0d1e6','#a6bddb','#74a9cf','#3690c0','#0570b0','#045a8d','#023858']
const BuPuGn:`#${string}`[] = ['#fff7fb','#ece2f0','#d0d1e6','#a6bddb','#67a9cf','#3690c0','#02818a','#016c59','#014636']
const PuRd:`#${string}`[] = ['#f7f4f9','#e7e1ef','#d4b9da','#c994c7','#df65b0','#e7298a','#ce1256','#980043','#67001f']
const RdPu:`#${string}`[] = ['#fff7f3','#fde0dd','#fcc5c0','#fa9fb5','#f768a1','#dd3497','#ae017e','#7a0177','#49006a']
const YiGn:`#${string}`[] = ['#ffffe5','#f7fcb9','#d9f0a3','#addd8e','#78c679','#41ab5d','#238443','#006837','#004529']
const YiGnBu:`#${string}`[] = ['#ffffd9','#edf8b1','#c7e9b4','#7fcdbb','#41b6c4','#1d91c0','#225ea8','#253494','#081d58']
const YiOrBr:`#${string}`[] = ['#ffffe5','#fff7bc','#fee391','#fec44f','#fe9929','#ec7014','#cc4c02','#993404','#662506']

const colorPallet:`#${string}`[][] = [
    GnBu,
    OrRd,
    BuPu,
    BuPuGn,
    PuRd,
    RdPu,
    YiGn,
    YiGnBu,
    YiOrBr
]

export default colorPallet